import React, {useState, useEffect, useRef} from "react";
import { Row,Col } from 'react-bootstrap';
import styled from "styled-components";
import Titulo from "../../globals/Title";
import CSVExport from "./CSVExport";
import Switch from "../../globals/Switch";
import DetalleAccions from "./DetalleAccions";

const HeaderContainer = styled(Row)`
  margin: 0;
  width: 100%;

`;
const HeaderContainerM = styled(Row)`
  margin: 0;
  width: 100%;
  min-height:30px;
`;
const Container = styled(Row)`
  margin:0;
  padding:0;
  display:flex;
`;
const ColStyle = styled(Col)`
  margin:0;
  padding:0;
  display:flex;
  justify-content:${props => props.align};
  align-items:center;
`;
function Header (props){
  return (
    <Container id="principal_header_container">
      
      <HeaderContainer id="header_container">
        <ColStyle align={'start'}>
          <Titulo tipo={'Reporte'} nombre={'Ventas Proveedor vs Periodo'} showDetalle={props.isDetalle} filtro={props.actualGridConcepto}/>
        </ColStyle>
        <ColStyle md={'auto'} align={'end'} style={{marginTop:'8px',marginRight:'16px'}}>
            <CSVExport  data={props.dataCSV} concepto={props.concepto.current}/>
        </ColStyle>
        <ColStyle md={'auto'} align={'end'} style={{marginTop:'0px'}}>
          <span style={{marginRight:'8px'}}>Mostrar Grafico:</span>
          <Switch 
            checked={props.showGraph} 
            onChange={props.toogleSwitch}
            id={'switch_grafico'}
          />
        </ColStyle>
      </HeaderContainer>
      <HeaderContainerM >
        <DetalleAccions 
          showDetalleOptions={props.showDetalleOptions}
          verDetalle={props.verDetalle}
          regresarDetalle={props.regresarDetalle}
          actualSelectedRows={props.actualSelectedRows}
          actualSelectedRowsComplete={props.actualSelectedRowsComplete}
          isDetalle={props.isDetalle}
          isDetalleHistorico={props.isDetalleHistorico}
        />
      </HeaderContainerM>
     
    </Container>
    
  );
}
export default Header;